module.exports = __webpack_public_path__ + "media/flags/sh-4d310917.svg";